import './ImportacaoIndicesProjecao.css'
import { useRef, useState } from 'react';
import { post } from '../../services/api';
import AdminSection from "../AdminSection/AdminSection";
import DownloadIcon from '@mui/icons-material/Download';
import { TailSpin } from "react-loader-spinner";
import Select from 'react-select';

export default function ImportacaoIndicesProjecao({ setNotifier }) {

    const [valorBaseCSVFileName, setValorBaseCSVFileName] = useState(undefined);
    const [file, setFile] = useState(null);
    const inputRef = useRef(null);
    const [isFetchingDataImportacao, setIsFetchingDataImportacao] = useState(false);
    const [indicadorImportacao, setIndicadorImportacao] = useState(null);
    const [disabledImportacao, setDisabledImportacao] = useState(true);

    const indicadores = [
        { value: 1, label: 'Mercantil' },
        { value: 2, label: 'Juros' },
        { value: 3, label: 'Serviços' },
        { value: 5, label: 'Inadimplência' },
    ];
    const optionsIndicadores = indicadores.map((indicador) => ({
        value: indicador.value,
        label: indicador.label,
    }));

    async function importarIndices() {
        try {

            const idUsuario = localStorage.getItem("idusuario");
            const formData = new FormData();
            const authToken = localStorage.getItem('adminToken');

            formData.append('file', file);
            formData.append('idusuario', idUsuario);
            formData.append('indicador', indicadorImportacao.value);

            setIsFetchingDataImportacao(true);
            
            const response = await post('/admin/importarindicesprojecao', formData, authToken);
            
            setIsFetchingDataImportacao(false);

            if (response.Sucesso) {
                setNotifier(true, response.Mensagem);
            } else {
                setNotifier(false, response.Mensagem);

            }
            limparInput();
        } catch (error) {
            setNotifier(false, 'Erro durante a importação!');
            console.error('Erro durante a importação:', error);
        }
    }

    const handleChangeIndicadorImportacao = (selectedOption) => {
        setIndicadorImportacao(selectedOption);
        setDisabledImportacao(false);
    };

    function baixarExemploCSV() {
        const csvData = [
            ['dia', 'mes', 'ano', 'indice'],
            [1, 9, 2024, 0],
            [2, 9, 2024, 0.03031112],
            [3, 9, 2024, 0.03190644],
            [4, 9, 2024, 0.03669241],
            [5, 9, 2024, 0.03828773],
            [6, 9, 2024, 0.04785966],
            [7, 9, 2024, 0],
            [8, 9, 2024, 0],
            [9, 9, 2024, 0.04626434],
            [10, 9, 2024, 0.04466902],
            [11, 9, 2024, 0.04147837],
            [12, 9, 2024, 0.04466902],
            [13, 9, 2024, 0.04626434],
            [14, 9, 2024, 0.04785966],
            [15, 9, 2024, 0],
            [16, 9, 2024, 0.04466902],
            [17, 9, 2024, 0.04121144],
            [18, 9, 2024, 0.03988305],
            [19, 9, 2024, 0.04147837],
            [20, 9, 2024, 0.04307370],
            [21, 9, 2024, 0.04466902],
            [22, 9, 2024, 0],
            [23, 9, 2024, 0.04147837],
            [24, 9, 2024, 0.03988305],
            [25, 9, 2024, 0.03828773],
            [26, 9, 2024, 0.04307370],
            [27, 9, 2024, 0.04147837],
            [28, 9, 2024, 0.04466902],
            [29, 9, 2024, 0],
            [30, 9, 2024, 0.03988305]
        ];
    
        const csvContent = csvData.map(e => e.join(";")).join("\n");
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'exemploIndiceProjecao.csv';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    function limparInput() {
        setFile(null);
        inputRef.current.value = null;
        setValorBaseCSVFileName(undefined);
    }

    return <>
        <AdminSection
            etapa={1} titulo={'Selecione os filtros'}
        >
            <div className='admin-filtros-dividos p-8'>
                <div className='admin-filtros-left'>
                    <div>
                        <label style={{ whiteSpace: 'nowrap' }} htmlFor="mes">Selecione o indicador</label>
                        <Select
                            name="indicador"
                            id="indicador"
                            className="react-select"
                            classNamePrefix="react-select"
                            value={indicadorImportacao}
                            onChange={handleChangeIndicadorImportacao}
                            options={optionsIndicadores}
                            isClearable={false}
                            isSearchable={false}
                            placeholder="Indicador"
                        />
                    </div>
                </div>
            </div>
        </AdminSection>

        <AdminSection
            etapa={2} titulo={'Importar Índices'} disabled={disabledImportacao}
        >

            <div className='p-8' style={{ paddingBottom: "16px" }}>
                <div className="texto-csv">
                    <span className="bold-text">Importe seu arquivo clicando no botão abaixo</span>
                    <div className="normal-text">O arquivo deve ser em formato CSV(Separado por virgulas).</div>
                    <div className="font-bold text-[20px] text-red-c1">A soma dos índices no mês não deve exceder 1.</div>
                </div>

                <div className='importar-csv'>
                    <label htmlFor="file_input" className="btn-label">Importar CSV</label>
                    <input type="file" accept='.csv' ref={inputRef} name='file_input' id="file_input" onChange={(e) => {
                        setValorBaseCSVFileName(e.target.files[0].name);
                        setFile(e.target.files[0]);
                    }} />
                    <label className='muda-nome'>{valorBaseCSVFileName === undefined ? '' : valorBaseCSVFileName}</label>
                </div>
            </div>

            <div className='animal-valorBase-buttons' style={{ textAlign: "center", padding: "0px" }}>
                <button
                    className='animal-refresh-btn'
                    onClick={limparInput}>Cancelar
                </button>
            </div>
            <div className="button-container">
                <button type="button" className='download-btn' onClick={baixarExemploCSV}> <DownloadIcon
                    style={{ width: '25px', height: '25px', marginRight: '10px' }} /> Exportar modelo</button>

                <button type="button" className="animal-save-btn" onClick={importarIndices}>
                    {isFetchingDataImportacao ? (
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <TailSpin color="#ffffff" height={20} width={39} />
                        </div>
                    ) : (
                        "Enviar CSV"
                    )}
                </button>
            </div>

        </AdminSection>

    </>
}
